import api from "./api";

export const getExceptionDetail = async (queryParam) => {
  return api
    .get({
      endpoint: "/exception-time-booking/list/by-time-book",
      port: process.env.REACT_APP_PORT_OPENHOUR,
      queryParam,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
